import { Component, OnInit } from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import {NODE_TYPE, FundingSourceReserve} from "./funding-source-reserve";

@Component({
  selector: 'app-funding-source-reserve',
  templateUrl: './funding-source-reserve.component.html',
  styleUrls: ['./funding-source-reserve.component.scss']
})
export class FundingSourceReserveComponent extends NodeBuilder implements OnInit {

  fundingSourceReserve: FundingSourceReserve;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
    this.fundingSourceReserve = new FundingSourceReserve();
  }

  set buildForm(stepData: any) {
    this.formGroup = this.fundingSourceReserve.toForm(stepData, this.canEdit)
  }

  get getStepData(): {} {
    this.fundingSourceReserve.setNodeData(this.formGroup.getRawValue());
    return this.fundingSourceReserve.nodeData;
  }

  get isNodeValid(): boolean {
    return this.isValidateForm();
  }
}
